<template>
  <div>
    <v-card>
      <v-card-text>
        <div class="partner-tab-section">
          <div class="refined-header">
            <div>
              <h2 class="refined-title">MarketPlace Şirket Eşleştirme</h2>
              <p class="refined-subtitle">Tenant, pazaryeri ve şirket bazlı eşleştirmeleri yönetebilirsiniz</p>
            </div>
            <button type="button" class="refined-primary-btn" @click="openUpsertDialog()">
              <v-icon small class="mr-1">add</v-icon>
              Yeni Eşleştirme
            </button>
          </div>

          <div class="refined-filters">
            <div class="refined-filter-item">
              <label class="refined-filter-label">Tenant</label>
              <select v-model="filters.tenantId" class="refined-select" @change="loadItems">
                <option :value="null">Tümü</option>
                <option v-for="opt in tenantOptions" :key="opt.tenantId" :value="opt.tenantId">{{ opt.tenantName }}</option>
              </select>
            </div>
            <div class="refined-filter-item">
              <label class="refined-filter-label">Pazaryeri</label>
              <select v-model="filters.mpId" class="refined-select" @change="loadItems">
                <option :value="null">Tümü</option>
                <option v-for="opt in marketplaceOptions" :key="opt.mpId" :value="opt.mpId">{{ opt.mpName }}</option>
              </select>
            </div>
            <div class="refined-filter-item">
              <label class="refined-filter-label">Şirket</label>
              <select v-model="filters.companyId" class="refined-select" @change="loadItems">
                <option :value="null">Tümü</option>
                <option v-for="opt in companyOptions" :key="opt.id" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <button type="button" class="refined-action-btn" @click="loadItems">Yenile</button>
          </div>

          <div class="refined-table-wrap">
            <div class="refined-table-scroll">
              <table class="refined-table">
                <thead>
                  <tr>
                    <th>Tenant</th>
                    <th>Pazaryeri</th>
                    <th>Şirket</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="4" class="refined-loading">
                      <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                      Yükleniyor...
                    </td>
                  </tr>
                  <tr v-else-if="!items.length">
                    <td colspan="4" class="refined-empty">Kayıt yok</td>
                  </tr>
                  <tr v-for="(item, i) in items" :key="item.id || i" class="refined-row">
                    <td>{{ getTenantName(item.tenantId) }}</td>
                    <td>{{ getMpName(item.mpId) }}</td>
                    <td class="refined-cell-bold">{{ getCompanyName(item.companyId) }}</td>
                    <td>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <button type="button" class="refined-action-btn" v-on="on">İşlem</button>
                        </template>
                        <v-card class="refined-menu-card">
                          <div class="refined-menu-body">
                            <button type="button" class="refined-menu-btn refined-menu-btn-primary" @click="openUpsertDialog(item)">DÜZENLE</button>
                            <div class="refined-menu-divider"></div>
                            <button type="button" class="refined-menu-btn refined-menu-btn-error" @click="openDelete(item)">SİL</button>
                          </div>
                        </v-card>
                      </v-menu>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="deleteDialog" max-width="420" persistent>
      <v-card>
        <v-card-title class="headline">Silme Onayı</v-card-title>
        <v-card-text>
          Bu eşleştirmeyi silmek istediğinizden emin misiniz?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="deleteDialog = false" :disabled="deleting">İptal</v-btn>
          <v-btn color="error" @click="confirmDelete" :loading="deleting">Sil</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="upsertDialog" max-width="720" persistent>
      <v-card class="bank-modal">
        <v-card-title class="headline white--text primary elevation-2">
          <v-icon left color="white" size="28">link</v-icon>
          <span class="font-weight-bold">{{ upsertId ? 'Eşleştirme Düzenle' : 'Yeni Eşleştirme' }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeUpsertDialog" :disabled="saving || companiesLoading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container grid-list-md>
            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 primary--text py-2">
                <v-icon left color="primary">tune</v-icon>
                Bilgiler
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm4 class="pr-sm-2">
                    <v-select
                      v-model="upsertModel.tenantId"
                      :items="tenantOptions"
                      item-text="tenantName"
                      item-value="tenantId"
                      label="Tenant"
                      outlined
                      dense
                      :disabled="saving"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="px-sm-2">
                    <v-select
                      v-model="upsertModel.mpId"
                      :items="marketplaceOptions"
                      item-text="mpName"
                      item-value="mpId"
                      label="Pazaryeri"
                      outlined
                      dense
                      :disabled="saving"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="pl-sm-2">
                    <v-select
                      v-model="upsertModel.companyId"
                      :items="companyOptions"
                      item-text="name"
                      item-value="id"
                      label="Şirket"
                      outlined
                      dense
                      :loading="companiesLoading"
                      :disabled="saving || companiesLoading"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeUpsertDialog" class="px-4" :disabled="saving || companiesLoading">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn color="primary" depressed class="white--text px-4" :loading="saving" :disabled="companiesLoading" @click="saveUpsert">
            <v-icon left>check</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mpCompaniesApi from '@/api/mpCompanies';
import companiesApi from '@/api/companies';

const DEFAULT_TENANTS = [
  { tenantId: 1, tenantName: 'ALTINDAFIRSAT' },
  { tenantId: 2, tenantName: 'E-ALTIN' },
];

const DEFAULT_MARKETPLACES = [
  { mpId: 1, mpName: 'Hepsiburada' },
  { mpId: 2, mpName: 'Alışgidiş' },
  { mpId: 3, mpName: 'Trendyol' },
  { mpId: 4, mpName: 'Idefix' },
  { mpId: 5, mpName: 'Idia' },
  { mpId: 6, mpName: 'n11' },
];

export default {
  data() {
    return {
      loading: false,
      deleting: false,
      deleteDialog: false,
      itemToDelete: null,
      upsertDialog: false,
      saving: false,
      upsertId: null,
      upsertModel: {
        tenantId: null,
        mpId: null,
        companyId: null,
      },
      tenantOptions: DEFAULT_TENANTS,
      marketplaceOptions: DEFAULT_MARKETPLACES,
      companyOptions: [],
      companiesById: {},
      companiesLoading: false,
      filters: {
        tenantId: null,
        mpId: null,
        companyId: null,
      },
      items: [],
    };
  },
  methods: {
    getTenantName(tenantId) {
      const match = (this.tenantOptions || []).find((x) => x.tenantId === tenantId);
      return match ? match.tenantName : tenantId;
    },
    getMpName(mpId) {
      const match = (this.marketplaceOptions || []).find((x) => x.mpId === mpId);
      return match ? match.mpName : mpId;
    },
    getCompanyName(companyId) {
      const c = this.companiesById[String(companyId)];
      return c && c.name ? c.name : companyId;
    },
    async loadCompanies() {
      this.companiesLoading = true;
      try {
        const res = await companiesApi.getCompanies();
        const list = res && res.data ? res.data : [];
        this.companyOptions = list;
        const map = {};
        list.forEach((c) => {
          if (c && c.id) map[String(c.id)] = c;
        });
        this.companiesById = map;
      } catch (e) {
        this.companyOptions = [];
        this.companiesById = {};
      } finally {
        this.companiesLoading = false;
      }
    },
    async loadItems() {
      this.loading = true;
      try {
        const res = await mpCompaniesApi.getMpCompanies(this.filters);
        this.items = res && res.data ? res.data : [];
      } catch (e) {
        this.items = [];
        this.$store.state.dialog = true;
        this.$store.state.message = 'Eşleştirmeler alınamadı.';
      } finally {
        this.loading = false;
      }
    },
    openUpsertDialog(item) {
      const isEdit = !!(item && item.id);
      this.upsertId = isEdit ? item.id : null;
      this.upsertModel = {
        tenantId: isEdit ? item.tenantId : null,
        mpId: isEdit ? item.mpId : null,
        companyId: isEdit ? item.companyId : null,
      };
      this.upsertDialog = true;
    },
    closeUpsertDialog(force = false) {
      if (this.saving && !force) return;
      this.upsertDialog = false;
      this.upsertId = null;
      this.upsertModel = { tenantId: null, mpId: null, companyId: null };
    },
    async saveUpsert() {
      const tenantId = this.upsertModel.tenantId;
      const mpId = this.upsertModel.mpId;
      const companyId = this.upsertModel.companyId;
      if (!tenantId || !mpId || !companyId) return;

      this.saving = true;
      try {
        const payload = { tenantId, mpId, companyId };
        if (this.upsertId) {
          await mpCompaniesApi.putMpCompany(this.upsertId, payload);
        } else {
          await mpCompaniesApi.postMpCompany(payload);
        }
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kaydedildi.';
        this.closeUpsertDialog(true);
        await this.loadItems();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kaydetme sırasında hata oluştu.';
      } finally {
        this.saving = false;
      }
    },
    openDelete(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    async confirmDelete() {
      if (!this.itemToDelete || !this.itemToDelete.id) return;
      this.deleting = true;
      try {
        await mpCompaniesApi.deleteMpCompany(this.itemToDelete.id);
        this.deleteDialog = false;
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kayıt silindi.';
        await this.loadItems();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Silme sırasında hata oluştu.';
      } finally {
        this.deleting = false;
        this.itemToDelete = null;
      }
    },
  },
  async mounted() {
    await this.loadCompanies();
    await this.loadItems();
  },
};
</script>

<style scoped>
.bank-modal {
  overflow: hidden;
}

.modern-card {
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.26) !important;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08) !important;
  overflow: hidden;
}

.partner-tab-section {
  max-width: 80rem;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.refined-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.refined-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.025em;
}

.refined-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0.25rem 0 0 0;
}

.refined-primary-btn {
  display: inline-flex;
  align-items: center;
  background: #2563eb;
  color: #fff;
  padding: 0.625rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  border: none;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.2);
  transition: background 0.2s, box-shadow 0.2s;
}

.refined-primary-btn:hover {
  background: #1d4ed8;
}

.refined-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
  align-items: end;
}

.refined-filter-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.refined-filter-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.refined-select {
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  font-size: 0.875rem;
  color: #0f172a;
  min-width: 180px;
  background: #fff;
}

.refined-select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}

.refined-table-wrap {
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.refined-table-scroll {
  overflow-x: auto;
}

.refined-table {
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}

.refined-table thead tr {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.refined-table th {
  padding: 1rem 1.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.refined-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}

.refined-table tbody tr:hover {
  background: rgba(248, 250, 252, 0.7);
}

.refined-table td {
  padding: 1rem 1.5rem;
  font-size: 0.875rem;
  color: #475569;
}

.refined-cell-bold {
  font-weight: 600;
  color: #1e293b;
}

.refined-loading,
.refined-empty {
  text-align: center;
  padding: 2rem !important;
  color: #64748b;
}

.refined-action-btn {
  padding: 0.35rem 0.75rem;
  border-radius: 0.375rem;
  border: none;
  background: #2563eb;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.refined-action-btn:hover {
  background: #1d4ed8;
}

.refined-menu-card {
  border-radius: 0.625rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.refined-menu-body {
  padding: 0.5rem;
  min-width: 180px;
}

.refined-menu-btn {
  display: block;
  width: 100%;
  padding: 0.625rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s, filter 0.2s;
  margin-bottom: 0.375rem;
}

.refined-menu-btn:hover {
  opacity: 0.92;
  filter: brightness(1.05);
}

.refined-menu-btn-primary {
  background: #2563eb;
}

.refined-menu-btn-error {
  background: #dc2626;
}

.refined-menu-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0.5rem 0;
}
</style>
